<template lang="pug">
filter-detail-container(
  :title="$t('filter_data_created_on')"
  @back="back"
  @save="save"
)
  template(v-slot:body)
    .pa-6
      div {{ $t('filter_customer_that_are_created') }}:
      yc-select.mt-4(v-model="condition" :items="options")
      yc-text-field.mt-4(label="Date selection" v-model="dates" disabled)
      v-card.mt-8(outlined)
        yc-date-picker(:parentDate.sync="dates" :range="condition === 'between'")
</template>

<script>
import FilterDetailContainer from './FilterDetailContainer.vue'

export default {
  props: ['filter'],
  components: { FilterDetailContainer },
  data: () => ({
    condition: 'before',
    dates: null,
    options: [
      { id: 'before', label: 'Before' },
      { id: 'after', label: 'After' },
      { id: 'exact', label: 'Exact date' }
    ],
  }),
  created() {
    const { before, after, exact } = this.filter
    if (before) {
      this.condition = 'before'
      this.dates = before
    }
    if (after) {
      this.condition = 'after'
      this.dates = after
    }
    if (exact) {
      this.condition = 'exact'
      this.dates = exact
    }
  },
  methods: {
    save() {
      const filter = this.getFilterData()
      this.$emit('update:filter', filter)
      this.back()
    },
    getFilterData() {
      switch (this.condition) {
        case 'before':
          return { before: this.dates }
        case 'after':
          return { after: this.dates }
        case 'exact':
          return { on: this.dates }
        case 'between':
          return {
            after: this.dates[0],
            before: this.dates[1]
          }
        default:
          return {}
      }
    },
    back() {
      this.$emit('onBack')
    }
  }
}
</script>